module.exports = __webpack_public_path__ + "static/media/scandskw_1.44055aff.ico";